import Layout from '@/pages/layout/'

export const topBar = [
	{
		path:"/",
		name:"home",
		redirect:"/home",
		meta : {
			title:"首页",
		},
		component:Layout,
		children:[
			{
				path:"/home",
				name:"home",
				title:"首页",
				component:() => import('@/pages/home')
			},
			{
				path:"/news",
				name:"news",
				title:"新闻公告",
				component:() => import('@/pages/news')
			},
			{
				path:"/yxfc",
				name:"yxfc",
				title:"院校风采",
				component:() => import('@/pages/yxfc')
			},
			{
				path:"/gxyxList",
				name:"gxyxList",
				title:"院校列表",
				component:() => import('@/pages/gxyxList')
			},
			{
				path:"/szzy",
				name:"szzy",
				title:"思政资源",
				component:() => import('@/pages/szzy')
			},
			{
				path:"/kcsz",
				name:"kcsz",
				title:"思政课程",
				component:() => import('@/pages/kcsz')
			},
			{
				path:"/szjk",
				name:"szjk",
				title:"思政金课",
				component:() => import('@/pages/szjk')
			},
			{
				path:"/szjkDetail",
				name:"szjkDetail",
				title:"思政金课详情",
				component:() => import('@/pages/szjk/szjkDetail')
			},
			{
				path:"/sfk_play",
				name:"sfk_play",
				title:"示范课详情",
				component:() => import('@/pages/sfk_play')
			},
			{
				path:"/resource_play",
				name:"resource_play",
				title:"资源详情",
				component:() => import('@/pages/resource_play')
			},
			{
				path:"/news_play",
				name:"news_play",
				title:"新闻详情",
				component:() => import('@/pages/news_play')
			}
		]
	},
	{
		path:"*",
		name:"error",
		meta:{
			title:"错误"
		},
		component: () => import('@/pages/error') 
	}
]

export const routers = topBar